import { useState } from "react";
import ProjectModal from "../ProjectModal";

import semesterProject1 from "../../assets/projects/semester-project-1.png";
import semesterProject2 from "../../assets/projects/semester-project-2.png";
import jsFrameworksCa from "../../assets/projects/js-frameworks-ca.png";
import projectExam2 from "../../assets/projects/project-exam-2.png";
import projectExam1 from "../../assets/projects/project-exam-1.png";

const projects = [
  {
    id: 1,
    title: "Project Exam 2",

    shortDescription:
      "A Holidaze venue booking application with visitor, customer and venue manager functionality.",

    fullDescription:
      "Holidaze is a venue booking application developed as part of Project Exam 2 at Noroff. The website allows visitors to browse venues, search and filter listings, and view venue details. Registered customers can book stays and manage their profile, while venue managers can create, edit, delete and manage their own venues.",

    image: projectExam2,

    github:
      "https://github.com/Veronicabrun/project-exam-2-holidaze.git",

    live:
      "https://holidaze-by-veronica.netlify.app/",

    prototypeWeb:
      "https://xd.adobe.com/view/c0b65d21-dd51-4cfd-943e-ade24cbfb03d-95e5/",

    prototypeMobile:
      "https://xd.adobe.com/view/0d97c839-0b59-4b1e-bb3b-6abcbdbacf79-58c4/",

    styleGuide:
      "https://xd.adobe.com/view/80c86022-a748-49a1-a0c4-096f7e378225-d59b/",

    tags: ["React", "React Router", "SCSS", "Responsive", "Testing"],

    featureSections: [
      {
        title: "Visitors",
        items: [
          "View the home page",
          "View all venues",
          "Search and filter venues",
          "View details for a specific venue",
          "View venue images and information",
          "Cannot book venues",
          "Cannot access profile features",
        ],
      },

      {
        title: "Registered customers",
        items: [
          "Register with a stud.noroff.no email",
          "Login and logout",
          "Book venues",
          "Select booking dates using React Datepicker",
          "Select number of guests",
          "View upcoming bookings",
          "View booked venues",
          "Update avatar",
        ],
      },

      {
        title: "Venue managers",
        items: [
          "Access visitor features",
          "Create new venues",
          "Edit owned venues",
          "Delete owned venues",
          "View bookings made on owned venues",
          "Update avatar",
        ],
      },
    ],

    technologies: [
      "React",
      "Create React App",
      "React Router DOM",
      "SCSS Modules",
      "React Datepicker",
      "Noroff Holidaze API",
      "Netlify",
      "ESLint via react-scripts",
      "Jest",
      "React Testing Library",
    ],
  },

  {
    id: 2,

    title: "JavaScript Frameworks CA",

    shortDescription:
      "A React e-commerce store with product search, cart functionality and checkout flow.",

    fullDescription:
      "JavaScript Frameworks CA is an e-commerce store built with React and the Noroff Online Shop API. The goal of the assignment was to apply React knowledge by building a responsive online store with product listing, individual product pages, cart functionality, checkout flow and a validated contact form.",

    image: jsFrameworksCa,

    github:
      "https://github.com/Veronicabrun/react-ecom-store.git",

    live:
      "https://veronicabp-react-store.netlify.app/",

    tags: ["React", "React Router", "SCSS", "Responsive", "Testing"],

    featureSections: [
      {
        title: "Homepage",
        items: [
          "Display a list of products from the Noroff Online Shop API",
          "Use product cards for each product",
          "Include a look-ahead search bar",
          "Filter products while typing in the search field",
          "Link each product to an individual product page",
        ],
      },

      {
        title: "Product and cart",
        items: [
          "Use dynamic routes for individual product pages",
          "Display product title, image, description and reviews",
          "Display discounted price",
          "Show discount information when price and discountedPrice are different",
          "Add products to the cart",
          "Show the number of cart items in the cart icon",
          "Display products and total price on the cart page",
        ],
      },

      {
        title: "Checkout and contact",
        items: [
          "Checkout button leads to checkout success page",
          "Checkout success page confirms the order",
          "Cart is cleared after successful checkout",
          "Contact page includes form validation",
          "Validate full name, subject, email and body fields",
        ],
      },
    ],

    technologies: [
      "React",
      "Create React App",
      "React Router DOM",
      "React Hook Form",
      "Yup",
      "SCSS",
      "Noroff Online Shop API",
      "Netlify",
      "Jest",
      "React Testing Library",
    ],
  },

  {
    id: 3,

    title: "Semester Project 2",

    shortDescription:
      "An auction website where users can create listings, place bids and manage their profile.",

    fullDescription:
      "Semester Project 2 is an auction website built as part of the third semester at Noroff. The goal was to create a front-end application for the Noroff Auction API where users can list items for auction, bid on other users’ listings, manage their profile and use credits. Non-registered users can search through listings, while registered users can bid and manage auction activity.",

    image: semesterProject2,

    github:
      "https://github.com/Veronicabrun/semester-project-2.git",

    live: "https://semesterproject2vbp.netlify.app/",

    prototypeWeb:
      "https://xd.adobe.com/view/8e75e7d2-e16e-49ff-bdfc-25d8d0de0fd1-db26/",

    prototypeMobile:
      "https://xd.adobe.com/view/940dfaf5-5fb5-4613-b551-ff4dca37b94e-c15e/",

    tags: [
      "JavaScript",
      "Bootstrap",
      "SCSS",
      "Responsive",
      "Testing",
    ],

    featureSections: [
      {
        title: "Visitors",
        items: [
          "Search through auction listings",
          "View auction listings",
          "View listing information",
          "Cannot place bids without being registered",
        ],
      },

      {
        title: "Registered users",
        items: [
          "Register with a stud.noroff.no email",
          "Login and logout",
          "View total credit balance",
          "Update avatar and bio",
          "Create listings with title, deadline date, media gallery and description",
          "Edit and delete own listings",
          "Place bids on other users’ listings",
          "View bids made on a listing",
        ],
      },

      {
        title: "Project functionality",
        items: [
          "Front page carousel with auction listings",
          "Show more button to load more listings",
          "Bid directly from auction cards",
          "Detailed auction page showing bids and listing information",
          "Profile page with listings and bid activity",
          "Validated contact form",
          "Create, edit, delete and profile actions open in Bootstrap modals",
          "Uses environment variables for configuration",
        ],
      },
    ],

    technologies: [
      "HTML5",
      "JavaScript ES6 Modules",
      "Bootstrap 5.3",
      "Bootstrap Icons",
      "SCSS",
      "Vite",
      "Noroff Auction API",
      "Vitest",
      "Playwright",
      "ESLint",
      "Prettier",
      "Husky",
      "Netlify",
    ],
  },

  {
    id: 4,

    title: "Project Exam 1",

    shortDescription:
      "A blog site built with HTML, CSS, JavaScript and WordPress as a headless CMS.",

    fullDescription:
      "Project Exam 1 is a blog site developed as part of the first year at Noroff. The goal was to apply first-year frontend skills by building a fully functional blog website using HTML, CSS and JavaScript. Blog content is managed in WordPress as a headless CMS and fetched through the WordPress REST API.",

    image: projectExam1,

    github:
      "https://github.com/Veronicabrun/project-exam-1-design-studio.git",

    live:
      "https://project-exam-1-design-studio.netlify.app/",

    prototypeWeb:
      "https://xd.adobe.com/view/672558f5-bd97-4f7c-b445-c0f1642e94af-3276/",

    prototypeMobile:
      "https://xd.adobe.com/view/ebb7aecd-6f3c-4630-b100-de541bed2cd6-bee4/",

    moodboard:
      "https://xd.adobe.com/view/e796be43-ae81-4926-b69c-d3a7b473cd5f-b2c5/",

    tags: ["HTML", "CSS", "JavaScript", "Responsive", "WordPress"],

    featureSections: [
      {
        title: "Required pages",
        items: [
          "Home page",
          "About page",
          "List of blog posts",
          "Blog post specific pages",
          "Contact page",
        ],
      },

      {
        title: "Blog functionality",
        items: [
          "Latest posts section on the home page",
          "Desktop carousel showing four posts at a time",
          "Blog page shows the first 10 posts",
          "Load more button displays additional blog posts",
          "Blog post pages are built dynamically using query string parameters",
          "Page title changes based on the selected blog post",
          "Images open in a modal for a larger view",
          "Clicking outside the modal closes the image",
        ],
      },

      {
        title: "Contact and testing",
        items: [
          "Contact form with name, email, subject and message fields",
          "JavaScript validation with error messages",
          "Name must be more than 5 characters",
          "Email must be a valid email address",
          "Subject must be more than 15 characters",
          "Message must be more than 25 characters",
          "Hotjar was installed for user testing and insights",
          "User feedback was used to improve the project",
        ],
      },
    ],

    technologies: [
      "HTML5",
      "CSS",
      "JavaScript",
      "WordPress Headless CMS",
      "WordPress REST API",
      "Netlify",
      "GitHub",
      "Hotjar",
      "Adobe XD",
    ],
  },

  {
    id: 5,

    title: "Semester Project 1",

    shortDescription:
      "A responsive science museum website for children, families and school visitors.",

    fullDescription:
      "Semester Project 1 is a website for the Community Science Museum, an interactive science museum aimed at primary and middle school children aged 7–15 and families with young children. The goal was to create an informative, engaging and responsive website that encourages visitors to explore the museum.",

    image: semesterProject1,

    github:
      "https://github.com/Veronicabrun/Semester-Project-1.git",

    live:
      "https://eclectic-starlight-157592.netlify.app/",

    prototypeWeb:
      "https://xd.adobe.com/view/156ca733-1c76-47cd-8955-677195277815-403f/",

    prototypeMobile:
      "https://xd.adobe.com/view/78abf4d8-b00d-474f-b273-edef6ed224fa-2df8/",

    tags: ["HTML", "CSS", "Responsive", "Accessibility"],

    featureSections: [
      {
        title: "Project goal",
        items: [
          "Create a website for the Community Science Museum",
          "Target children aged 7–15 and families with young children",
          "Make the site informative, engaging and easy to use",
          "Encourage visitors to explore the museum",
        ],
      },

      {
        title: "Requirements",
        items: [
          "Design should appeal to the target audience",
          "Site should include at least 4–6 pages",
          "Use semantic and neatly indented HTML",
          "Use external CSS stylesheets following the DRY principle",
          "Consider typography, colour schemes and composition",
          "Images should be optimized and not make the site too heavy",
        ],
      },

      {
        title: "User experience",
        items: [
          "Responsive layout for different devices",
          "Accessible navigation and hierarchy",
          "Consider WCAG principles",
          "Use meta tags and alt text for accessibility",
          "Create an attractive and easy-to-use interface",
        ],
      },
    ],

    technologies: [
      "HTML5",
      "CSS",
      "Responsive Design",
      "Semantic HTML",
      "Accessibility",
      "WCAG Principles",
      "Netlify",
      "GitHub",
      "Adobe XD",
    ],
  },
];

function ProjectsSection() {
  const [selectedProject, setSelectedProject] = useState(null);

  return (
    <section
      id="projects"
      className="relative overflow-hidden bg-white px-6 py-28"
    >
      <div className="absolute left-6 top-20 h-28 w-28 rounded-full bg-pink-100"></div>

      <div className="absolute bottom-24 right-6 h-32 w-32 rounded-full bg-purple-100"></div>

      <div className="relative z-10 mx-auto max-w-7xl">
        <div className="text-center">
          <h2 className="text-4xl font-extrabold text-black sm:text-5xl">
            My{" "}
            <span className="bg-gradient-to-r from-pink-500 to-purple-600 bg-clip-text text-transparent">
              Projects
            </span>
          </h2>

          <p className="mx-auto mt-5 max-w-2xl text-gray-600">
            A selection of my course projects, documented with screenshots,
            GitHub repositories, live links and design prototypes.
          </p>
        </div>

        <div className="mt-24 grid gap-12 md:grid-cols-2 xl:grid-cols-3">
          {projects.map((project) => (
            <article
              key={project.id}
              className="group relative rounded-[2rem] bg-white p-5 shadow-xl transition duration-300 hover:-translate-y-2 hover:shadow-2xl"
            >
              <div className="absolute -right-3 -top-3 -z-10 h-full w-full rounded-[2rem] bg-purple-200 transition group-hover:bg-purple-300"></div>

              <div className="absolute -left-3 -top-3 -z-10 h-full w-full rounded-[2rem] bg-pink-200 transition group-hover:bg-pink-300"></div>

              <div className="overflow-hidden rounded-[1.5rem] bg-gradient-to-br from-pink-100 to-purple-100">
                <img
                  src={project.image}
                  alt={`Screenshot of ${project.title}`}
                  className="h-64 w-full object-cover object-top transition duration-500 group-hover:scale-105"
                />
              </div>

              <div className="pt-6">
                <h3 className="text-2xl font-extrabold text-black">
                  {project.title}
                </h3>

                <p className="mt-3 text-sm leading-relaxed text-gray-600">
                  {project.shortDescription}
                </p>

                <div className="mt-5 flex flex-wrap gap-2">
                  {project.tags.map((tag) => (
                    <span
                      key={tag}
                      className="rounded-full border border-pink-100 bg-pink-50 px-3 py-1 text-xs font-semibold text-purple-700"
                    >
                      {tag}
                    </span>
                  ))}
                </div>

                <button
                  type="button"
                  onClick={() => setSelectedProject(project)}
                  className="mt-6 rounded-full bg-gradient-to-r from-pink-500 to-purple-600 px-6 py-3 text-sm font-semibold text-white shadow-md transition duration-300 hover:scale-105"
                >
                  Read More
                </button>
              </div>
            </article>
          ))}
        </div>
      </div>

      <ProjectModal
        project={selectedProject}
        onClose={() => setSelectedProject(null)}
      />
    </section>
  );
}

export default ProjectsSection;